/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Params {
  manufacturerId: number;
  id: number;
}

export function deleteOneBaseMgmtManufacturerTargetControllerManufacturerTarget(http: HttpClient, rootUrl: string, params: DeleteOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteOneBaseMgmtManufacturerTargetControllerManufacturerTarget.PATH, 'delete');
  if (params) {
    rb.path('manufacturerId', params.manufacturerId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteOneBaseMgmtManufacturerTargetControllerManufacturerTarget.PATH = '/api/mgmt/manufacturer/{manufacturerId}/targets/{id}';
